<div #formlyFormContainer class="flex flex-col h-full">
    <ng-container *ngIf="!standalone && formViewModel">
        <div class="flex flex-col h-full overflow-hidden" *transloco="let t">
            <div class="flex flex-row w-full items-center place-content-between pl-4 pr-2 pt-2 pb-4">
                <span class="font-bold">{{ formViewModel.title }}</span>
                <button mat-icon-button (click)="close()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="flex-grow w-full px-4 mat-typography overflow-y-auto">
                <div class="flex flex-col mb-6 space-y-2" *ngIf="formViewModel.description">
                    <div class="text-hint">{{ formViewModel.description }}</div>
                </div>

                <formly-form
                    [model]="model"
                    (modelChange)="onModelChange($event)"
                    [fields]="fields"
                    [options]="options"
                    [form]="form"
                ></formly-form>
            </div>

            <div class="flex w-full p-4 place-content-between">
                <button mat-button (click)="close()">Cancelar</button>
                <div class="flex space-x-4">
                    <div class="flex space-x-4" *ngIf="bottomActions?.length > 0">
                        <button
                            *ngFor="let action of bottomActions"
                            mat-button
                            color="primary"
                            [disabled]="!form.valid || loading"
                            (click)="dispatchExtraAction(action.id)"
                            cdkFocusInitial
                        >
                            {{ action.text }}
                        </button>
                    </div>
                    <button
                        mat-button
                        color="primary"
                        [disabled]="!form.valid || loading"
                        (click)="save()"
                        cdkFocusInitial
                    >
                        {{ t("actions.save") }}
                    </button>
                </div>
            </div>
        </div>
    </ng-container>

    <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form" *ngIf="standalone"></formly-form>
</div>
